import { Button, Language } from "@chef/components";
import { useConfirmDialog } from "@chef/hooks";
import { BillingQuery } from "@chef/state-management";
import { CancelSubscriptionModal } from "./CancelSubscriptionModal";
import { intl } from "./CancelSubscripitonButtonComponent.Intl";

interface CancelSubscriptionButtonComponentProps {
  discounts?: Pick<
    BillingQuery["billing"]["discounts"][number],
    "disableOnFreeze" | "name" | "usesLeft" | "validEndDate" | "discountId"
  >[];
  onConfirm: () => void;
  language: Language;
  linkToPauseSubscriptionForPeriodPage: string;
  id?: string;
}

export const CancelSubscriptionButtonComponent = ({
  discounts,
  onConfirm,
  language = "no",
  linkToPauseSubscriptionForPeriodPage,
  id,
}: CancelSubscriptionButtonComponentProps) => {
  const discountsToBeLost =
    discounts?.filter(({ disableOnFreeze, usesLeft, validEndDate }) => {
      return (
        disableOnFreeze && usesLeft > 0 && new Date(validEndDate) > new Date()
      );
    }) || [];

  const { isShowing, handleCancel, handleShow, handleConfirm } =
    useConfirmDialog();

  const onClick = () => {
    if (discountsToBeLost.length > 0) {
      handleShow(onConfirm);
    } else {
      onConfirm();
    }
  };

  return (
    <>
      <CancelSubscriptionModal
        show={isShowing}
        closeModal={handleCancel}
        onConfirmCancellationClicked={handleConfirm}
        discountsToBeLost={discountsToBeLost.map(({ name }) => name)}
        language={language}
        linkToPauseSubscriptionForPeriodPage={
          linkToPauseSubscriptionForPeriodPage
        }
      />
      <Button
        data-testid="cancelSubscriptionButton"
        id={id}
        onClick={onClick}
        outlined
        tiny
        disabled={!discounts}
      >
        {intl.BUTTON_TEXT}
      </Button>
    </>
  );
};
